const retailPrices = {
  AL: 14.49,
  AK: 23.38,
  AZ: 14.11,
  AR: 12.34,
  CA: 29.54,
  CO: 13.56,
  CT: 34.44,
  FL: 15.85,
  GA: 13.3,
  HI: 43.18,
  ID: 10.24,
  IN: 15.08,
  IA: 12.52,
  KS: 13.83,
  KY: 12.61,
  LA: 11.17,
  MI: 18.25,
  MN: 14.54,
  MS: 14.08,
  MO: 12,
  MT: 12.28,
  NE: 11.3,
  NV: 17.59,
  NM: 13.75,
  NC: 13.21,
  ND: 10.24,
  OK: 12.39,
  OR: 12.5,
  SC: 14.3,
  SD: 11.79,
  TN: 11.93,
  UT: 10.85,
  VT: 20.74,
  VA: 14.65,
  WA: 10.96,
  WV: 14.41,
  WI: 16.87,
  WY: 11.21,
};

export const higherPrice = Object.values(retailPrices).sort().pop();

export default retailPrices;
